import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { BYPASS_BASE_URL } from 'core';
import { Observable, catchError, map, of } from 'rxjs';

// Build gia' ricaricata in questa scheda: evita di ricaricare all'infinito se il server restituisce ancora la pagina vecchia
const RELOADED_KEY = 'versionCheckReloaded';

interface BuildVersion {
  main?: string;
}

// Nome del bundle in esecuzione (main-<hash>.js), lo stesso che build/write-version.mjs scrive in version.json
function runningMain(): string | null {
  const src = document.querySelector<HTMLScriptElement>('script[src*="main"]')?.getAttribute('src');
  return src?.split('/').pop() ?? null;
}

// Con un index.html vecchio in cache gira la build precedente: se version.json indica un'altra build si ricarica la pagina.
// Senza version.json (ng serve, build senza lo script) non fa nulla.
export function checkVersion(): Observable<unknown> {
  const main = runningMain();
  return inject(HttpClient).get<BuildVersion>('version.json', {
    headers: new HttpHeaders({ 'Cache-Control': 'no-cache' }),
    context: new HttpContext().set(BYPASS_BASE_URL, true),
  }).pipe(
    map(version => {
      if (main && version?.main && version.main !== main && sessionStorage.getItem(RELOADED_KEY) !== version.main) {
        sessionStorage.setItem(RELOADED_KEY, version.main);
        window.location.reload();
      }
      return null;
    }),
    catchError(() => of(null)),
  );
}
